import { Avatar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CategoryPage from "./CategoryPage";
import Navbar from "../../User/Navbar";
import { useEffect } from "react";

export default function Hero() {
  const navigate = useNavigate();
  const location = useLocation();
  const name = location.state?.name;
  const link = location.state?.link
    ? location.state?.link
    : "https://images.unsplash.com/photo-1579444741963-5ae219cfe27c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
  const data = location.state?.data;

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      navigate("/blog");
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  return (
    <>
      <Navbar />
      <div className="relative !mb-10">
        {/* Hero Image Section */}
        <div className="relative h-[80vh] w-full">
          {/* Text Content Positioned Over Image */}
          <div className="absolute inset-0 z-10 flex flex-col justify-center items-start container mx-auto px-4">
            <div
              className="max-w-3xl space-y-6 p-8 rounded-lg bg-gradient-to-br from-black/80 via-gray-900/60 to-black/80 shadow-lg"
              style={{
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
              }}
            >
              {/* Tags */}
              <div className="flex space-x-3">
                <span className="bg-green-500 text-white px-4 py-2 text-sm font-semibold rounded shadow-md">
                  R
                </span>
                <span className="bg-yellow-500 text-white px-4 py-2 text-sm font-semibold rounded shadow-md">
                  T
                </span>
                <span className="bg-green-500 text-white px-4 py-2 text-sm font-semibold rounded shadow-md">
                  S
                </span>
              </div>

              {/* Title */}
              <h1
                className="text-3xl md:text-4xl font-extrabold text-white leading-snug tracking-wide"
                style={{
                  textShadow: "0px 3px 5px rgba(0, 0, 0, 0.7)",
                  lineHeight: "1.2",
                }}
              >
                Tax Updates & Compliance Guidelines
              </h1>

              {/* Breadcrumb */}
              <h6
                className="text-lg md:text-xl font-medium text-gray-200"
                style={{
                  textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
                }}
              >
                Home / Blogs /{" "}
                <span className="text-blue-400 font-semibold">{name}</span>
              </h6>
            </div>
          </div>

          {/* Hero Image */}
          <img
            src={link}
            alt="Hero img"
            style={{ height: "80vh", width: "100%" }}
            className="object-cover"
          />
        </div>
        <CategoryPage data={name} records={data} />
      </div>
    </>
  );
}
